import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LanguageService } from '../services/language.service';
import { NonStaticInterceptor } from './nonstatic.http-interceptor';

@Injectable()
export class I18nHttpInterceptor extends NonStaticInterceptor implements HttpInterceptor {
  constructor(private languageService: LanguageService) {
    super();
  }

  protected internalIntercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let reqHeaders = req.headers;
    const supportedLangs = this.languageService.getAvaliableLanguages();
    const reqLangs = new Array<string>();
    const currentLang = this.languageService.getAppLanguage();
    if (currentLang) {
      reqLangs.push(currentLang);
    }
    if (supportedLangs) {
      supportedLangs.filter((lang) => lang !== currentLang).forEach((lang) => reqLangs.push(lang));
    }
    reqHeaders = reqHeaders.set('Accept-Language', reqLangs);
    const i18nReq = req.clone({
      headers: reqHeaders
    });
    return next.handle(i18nReq);
  }
}
